<script>
    import BenefitBadge from "./BenefitBadge.svelte";
    import DiscountTag from "./DiscountTag.svelte";

    /**
 *
 *
 *
 *
 *
 *
 */

    /*                */
    const { pricing, variationHighlightText, variationId, showDiscountValue, variationDiscountValue } = $props();
    const priceMode = pricing.priceMode || "StatusQuo";

    const discountValue = $derived(showDiscountValue ? variationDiscountValue : null);

    const shouldOriginalPriceBeStrikeThrough = () => {
        return ["StatusQuo", "Strike", "StrikeRed"].includes(priceMode);
    };

    const shouldRetailPriceBeRed = () => {
        return ["StatusQuo", "Red", "StrikeRed"].includes(priceMode);
    };
</script>

<div class="reco_cinema__original-price">
    {#if pricing.originalPricePrefix}
        <span class="reco_cinema__uvp-string oc-copy-100" role="tabpanel">
            {pricing.originalPricePrefix}
        </span>
    {/if}
    {#if pricing.originalPrice}
        <span
            class="reco_cinema__nowrap oc-copy-100"
            role="tabpanel"
            class:reco_cinema__price-line-through={shouldOriginalPriceBeStrikeThrough()}
        >
            {pricing.originalPrice}
        </span>
    {/if}
</div>

{#if variationHighlightText || pricing.retailPricePrefix}
    <span class="oc-headline-50 reco_cinema__retail-price" role="tabpanel">
        <span class:reco_cinema__price-red={pricing.originalPrice && shouldRetailPriceBeRed()}>{pricing.retailPricePrefix}</span>
        <span class="reco_cinema__nowrap" role="tabpanel" class:reco_cinema__price-red={pricing.originalPrice && shouldRetailPriceBeRed()}
            >{pricing.retailPrice}</span
        >
        {#if variationHighlightText}
            <div class="oc-pt-25 reco_cinema__highlight-text" class:reco_cinema__price-red={pricing.originalPrice}>
                {variationHighlightText}
            </div>
        {/if}
    </span>
{:else}
    <span
        class="reco_cinema__retail-price reco_cinema__nowrap oc-headline-50"
        class:reco_cinema__price-red={pricing.originalPrice && shouldRetailPriceBeRed()}
        role="tabpanel"
    >
        {pricing.retailPrice}
    </span>
{/if}

{#if pricing.unitPrice}
    <div class="reco_cinema__price-per-unit oc-headline-10">
        <span role="tabpanel"> {pricing.unitPrice} </span>
    </div>
{/if}

<div class="reco_cinema__taglist">
    <DiscountTag {discountValue} />
    <BenefitBadge {variationId} />
</div>

<style lang="scss">
    .reco_cinema__original-price {
    }

    .reco_cinema__uvp-string {
        padding-right: var(--padding_within_cell);
    }

    .reco_cinema__nowrap {
        white-space: nowrap;
    }

    .reco_cinema__price-line-through {
        padding-right: var(--padding_within_cell);
        text-decoration: line-through;
    }

    .reco_cinema__retail-price {
        display: inline-block;
    }

    .reco_cinema__highlight-text {
        line-height: calc(1em + 10px);
        margin-top: -2px;
    }

    .reco_cinema__price-per-unit {
        padding: 6px 4px 6px 4px;
        color: var(--oc-semantic-color-text-secondary);
    }

    .reco_cinema__price-red {
        color: var(--oc-semantic-color-brand);
    }

    .reco_cinema__taglist {
        display: flex;
        flex-wrap: wrap;
    }
</style>
